import { MAX_LENGTH_BOOK_NOTE, SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createBookValidationSchema = Yup.object().shape({
  name: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  categoryId: Yup.number().min(1, SystemMessage.INPUT_REQUIRED),
  bookOption: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  price: Yup.number()
    .required(SystemMessage.INPUT_REQUIRED)
    .positive(SystemMessage.INPUT_INVALID_PRICE)
    .integer()
    .typeError(SystemMessage.INPUT_INVALID_PRICE),
  author: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  musicId: Yup.number().min(1, SystemMessage.INPUT_REQUIRED),
  description: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  elements: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required(SystemMessage.INPUT_REQUIRED),
      description: Yup.string().required(SystemMessage.INPUT_REQUIRED),
    })
  ),
});

export const createBookElementNoteValidationSchema = Yup.object().shape({
  textNote: Yup.string()
    .required(SystemMessage.INPUT_REQUIRED)
    .max(MAX_LENGTH_BOOK_NOTE, SystemMessage.CREATE_BOOK_NOTE_MAX_LENGTH),
});
